import React, { useEffect, useRef, useState } from 'react';
import { Bot, Send, X, Sparkles, Loader2 } from 'lucide-react';
import { AdminApi } from '../../services/api';
import './AdminCopilotDock.css';

const PROMPTS = [
  'Three-line brief: Academy, Talks, Connect',
  'Clear the action inbox',
  'Which QoreTalks guests should become mentors?',
  'What is at risk on QoreAcademy this week?',
];

const AdminCopilotDock = ({ token, open, onToggle }) => {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, open]);

  const send = async (text) => {
    const content = (text || input).trim();
    if (!content || !token || loading) return;
    setInput('');
    setMessages((m) => [...m, { role: 'user', content }]);
    setLoading(true);
    try {
      const res = await AdminApi.chatWithAgent(token, content);
      setMessages((m) => [
        ...m,
        {
          role: 'agent',
          content: res.success ? res.data.response : (res.message || 'No reply'),
          tools: res.data?.toolCalls || [],
        },
      ]);
    } catch (e) {
      setMessages((m) => [...m, { role: 'error', content: e.message }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={`nova-dock-fab ${open ? 'nova-dock-fab--open' : ''}`}
        onClick={onToggle}
        aria-label={open ? 'Close Nova' : 'Open Nova coworker'}
      >
        {open ? <X size={22} /> : <Bot size={22} />}
      </button>
      {open && (
        <aside className="nova-dock" aria-label="Nova coworker">
          <header className="nova-dock__head">
            <div className="nova-dock__identity">
              <Bot size={18} />
              <div>
                <strong>Nova</strong>
                <span>QoreNova coworker · v4</span>
              </div>
            </div>
            <button type="button" className="adm-icon-btn" onClick={onToggle} aria-label="Close">
              <X size={16} />
            </button>
          </header>
          <div className="nova-dock__body">
            {messages.length === 0 && (
              <div className="nova-dock__welcome">
                <Sparkles size={20} />
                <p>I can approve courses, review Talks guests, moderate Connect, and run cross-line workflows.</p>
                <div className="nova-dock__prompts">
                  {PROMPTS.map((p) => (
                    <button key={p} type="button" onClick={() => send(p)}>{p}</button>
                  ))}
                </div>
              </div>
            )}
            {messages.map((msg, i) => (
              <div key={i} className={`nova-dock__msg nova-dock__msg--${msg.role}`}>
                <p>{msg.content}</p>
                {msg.tools?.length > 0 && (
                  <ul className="nova-dock__tools">
                    {msg.tools.map((t, idx) => (
                      <li key={idx}>{t.name}: {t.result?.message || t.result?.status || 'done'}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
            {loading && (
              <div className="nova-dock__msg nova-dock__msg--agent">
                <Loader2 size={14} className="spin" /> Working…
              </div>
            )}
            <div ref={endRef} />
          </div>
          <form
            className="nova-dock__form"
            onSubmit={(e) => {
              e.preventDefault();
              send();
            }}
          >
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask Nova to do the work…"
            />
            <button type="submit" disabled={loading || !input.trim()} aria-label="Send">
              <Send size={16} />
            </button>
          </form>
        </aside>
      )}
    </>
  );
};

export default AdminCopilotDock;
